import { AdminsTable } from "../../components/admins/AdminsListTable.component";
import { AddAdminsButton } from "../../components/admins/AddNewButton.component";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { useState } from "react";
import { SearchInputField } from "../../components/generic/searchInputField.component";
export const AdminsListPage = () => {
  const [searchKey, setSearchKey] = useState<string>("");
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Admins <BreadCrumbSign /> List
          </p>
          <div className="d-flex align-items-center justify-content-between mb-3 px-1">
            <AddAdminsButton />
            <SearchInputField
              searchKey={searchKey}
              setSearchKey={setSearchKey}
            />
          </div>
          <AdminsTable searchKey={searchKey} />
        </div>
      </div>
    </div>
  );
};
